import { TypedDocumentNode, gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';

import { Sport } from '__generated__/globalTypes';
import Button from 'atoms/buttons/Button';
import { Horizontal, SBHorizontal } from 'atoms/layout/flex';
import { BodyM } from 'atoms/typography';
import { ClaimReferralRewardsDialog } from 'components/referral/ClaimReferralRewardsDialog';
import { glossary } from 'lib/glossary';

import { ReadyToClaimReferralBar_ReferralReward } from './__generated__/index.graphql';

type Props = {
  refereeRewards: ReadyToClaimReferralBar_ReferralReward[];
  openClaimDialog: boolean;
  toggleOpenClaimDialog: () => void;
  sport?: Sport;
};

export const ReadyToClaimReferralBar = ({
  refereeRewards,
  openClaimDialog,
  toggleOpenClaimDialog,
  sport,
}: Props) => {
  return (
    <>
      <SBHorizontal>
        <Horizontal gap={2}>
          <BodyM as="p" bold>
            <FormattedMessage
              id="Referral.ReadyToClaimReferralBar.yourRefereeRewardIsWaitingForYou"
              defaultMessage="Your referee reward is waiting for you! {gift}"
              values={{ gift: '🎁' }}
            />
          </BodyM>
        </Horizontal>
        <Button size="medium" color="primary" onClick={toggleOpenClaimDialog}>
          <FormattedMessage {...glossary.claim} />
        </Button>
      </SBHorizontal>
      <ClaimReferralRewardsDialog
        referralRewards={refereeRewards}
        open={openClaimDialog}
        onClose={toggleOpenClaimDialog}
        sport={sport}
      />
    </>
  );
};

ReadyToClaimReferralBar.fragments = {
  referralReward: gql`
    fragment ReadyToClaimReferralBar_ReferralReward on ReferralReward {
      id
      ...ClaimReferralRewardsDialog_referralReward
    }
    ${ClaimReferralRewardsDialog.fragments.referralReward}
  ` as TypedDocumentNode<ReadyToClaimReferralBar_ReferralReward>,
};
